// this function capitalizes a string
// for example, "test string" => "Test string"
export const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
